import React from 'react'
import LazyLoad from 'react-lazyload'
import { CoverImage } from '@!/Store/Common/components'
import { Box, SimpleGrid, Text, HStack } from '@chakra-ui/react'
import { NewTag } from '@!/User/Bookshelf/components/BookshelfTags'

// サムネイル表示
export default function BookshelfItems({ books, handleClickBook }) {
  return (
    <LazyLoad offset={100} once>
      <SimpleGrid columns={{ base: 3, md: 6 }} spacing={4}>
        {books.map((book) => (
          <Box key={book.content_id} cursor="pointer" onClick={() => handleClickBook(book.content_id)}>
            <Box>
              <CoverImage width="100%" src={book.image_url} alt={book.title_name} />
              <HStack spacing={1} fontSize="3xs" color="label.primary" pt="5px" alignItems="center">
                {book.new_release_flag && (
                  <Box w="13px" h="13px" minW="13px" maxW="13px">
                    <NewTag />
                  </Box>
                )}
                <Text whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
                  {book.title_name}
                </Text>
              </HStack>
            </Box>
          </Box>
        ))}
      </SimpleGrid>
    </LazyLoad>
  )
}
